// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../microservices/player_v2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#video-upload .filepond-infinite-loading svg{animation:spin 1s linear infinite}", ""]);
// Exports
module.exports = exports;
